if (!customElements.get('custom-button')) {
  class CustomButton extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      let controls = this.getAttribute('aria-controls') || this.getAttribute('href');

      if (controls) {
        if (controls.indexOf('#') > -1) controls = controls.split('#')[1];
        this.controlsElement = controls;
        this.addEventListener('click', this.onClick.bind(this));
      }
    }
    onClick(e) {
      e.preventDefault();
      let _this = this;
      if (e.target && e.target.closest('custom-button')) {
        _this = e.target.closest('custom-button');
      }
      //console.log('custombutton click', e, _this);

      if (_this.getAttribute('data-connected-popup') && this.closest('custom-modal')) {
        //console.log('close modal!', _this.closest('custom-modal'));
        var style = getComputedStyle(document.body);
        const animationTime = style.getPropertyValue('--animation-time');
        const animationFunction = style.getPropertyValue('--animation-function');
        document.documentElement.style.setProperty('--animation-time', 0);
        document.documentElement.style.setProperty('--animation-function', 'none');
        requestAnimationFrame(() => {
          _this.closest('custom-modal').close();
          requestAnimationFrame(() => {
            document.documentElement.style.setProperty('--animation-time', animationTime);
            document.documentElement.style.setProperty('--animation-function', animationFunction);
          });
        });
      }
      requestAnimationFrame(() => {
        //console.log('_this.controlsElement', _this.controlsElement);
        if (document.querySelector('[id="' + _this.controlsElement + '_modal"]')) {
          document.querySelectorAll('[id="' + _this.controlsElement + '_modal"]').forEach((el) => {
            el.toggle();
          });
        } else if (document.querySelector('[id="' + _this.controlsElement + '"]')) {
          document.querySelectorAll('[id="' + _this.controlsElement + '"]').forEach((el) => {
            if (el.tagName === 'DIALOG' && !el.hasAttribute('open')) {
              el.showModal();
              //console.log('click-custom-grid', el, el.querySelector('custom-grid[is="custom-slider"]'));
              if (el.querySelector('custom-grid[is="custom-slider"]')) {
                requestAnimationFrame(() => {
                  el.querySelector('custom-grid[is="custom-slider"]').setSlider();
                });
              }
            } else {
              if (el.hasAttribute('open')) {
                el.removeAttribute('open');
              } else {
                el.setAttribute('open', '');
              }
            }
          });
        }
      });
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
    }
  }
  customElements.define('custom-button', CustomButton);
}

if (!customElements.get('custom-modal')) {
  class CustomModal extends HTMLElement {
    constructor() {
      super();
      this.dialogEl = this.querySelector('dialog');
      let _this = this;
      document.addEventListener('click', (e) => {
        if (!_this.dialogEl.open) return;
        var rect = _this.dialogEl.getBoundingClientRect();
        var isInDialog =
          rect.top <= e.clientY &&
          e.clientY <= rect.top + rect.height &&
          rect.left <= e.clientX &&
          e.clientX <= rect.left + rect.width;
        if (!isInDialog) {
          //console.log('outside dialog!');
          _this.close();
        }
      });
      this.closeBtns = this.querySelectorAll('.close-drawer');
      this.closeBtns.forEach((btn) => {
        btn.addEventListener('click', this.close.bind(_this));
      });
      /*
      this.dialogEl.addEventListener('open', (e) => _this.onOpen);
      this.dialogEl.addEventListener('toggle', (e) => _this.onToggle);
      this.dialogEl.addEventListener('beforetoggle', (e) => _this.onToggle);
      this.addEventListener('click', (e) => _this.onToggle);
      */

      this.dialogEl.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          _this.close();
        }
      });
      this.dialogEl.addEventListener('focusout', (e) => {
        _this.onFocusOut(e.target);
      });
    }

    onOpen(e) {
      //console.log('modal opened', e, this);
    }
    onToggle(e) {
      //console.log('modal toggled', e, this);
    }

    onFocusOut(target) {
      if (target && this.contains(target)) {
        return;
      }

      requestAnimationFrame(() => {
        if (!this.contains(document.activeElement)) this.close();
      });
    }

    toggle() {
      //console.log('modal toggle', this);
      this.dialogEl.open && this.dialogEl.open !== 'false' ? this.close() : this.show();
    }

    show() {
      this.dialogEl.showModal();
      if (this.dialogEl.querySelector('custom-grid')) {
        requestAnimationFrame(() => {
          //console.log('setSlider from modal.js');
          this.dialogEl.querySelector('custom-grid').setSlider();
        });
      }
      if (this.querySelector('.drawer-content')) {
        this.querySelector('.drawer-content').focus();
      }
    }

    close() {
      //console.log('dialog close', this.dialogEl);
      this.dialogEl.close();
      if (this.querySelector('video')) {
        this.querySelector('video').pause();
        this.querySelector('[data-play-pause-btn]').classList.remove('playing');
      }

      const modalClosedEvent = new CustomEvent('modal:closed', {
        detail: { id: this.id },
        bubbles: true,
        cancelable: true,
      });
      this.dispatchEvent(modalClosedEvent);
    }
  }
  customElements.define('custom-modal', CustomModal);
}

if (!customElements.get('collapsible-details')) {
  document.querySelectorAll('details[' + window.Helpers.RWD.currentBreakpoint + '-open' + ']').forEach((el) => {
    el.open = true;
  });
  class CollapsibleDetails extends HTMLElement {
    constructor() {
      super();
      //self = this;
      this.detailsEl = this.querySelector('details');
      this.summaryEl = this.detailsEl.querySelector('summary');
      this.content = this.summaryEl.nextElementSibling;
      //this.detailsEl.addEventListener('focusout', this.onFocusOut.bind(this));
      const _this = this;
      if (this.shouldBeOpened()) {
        _this.open();
        /*
        const _this_opening_interval = setInterval(() => {
          console.log('_this_opening_interval', _this.detailsEl.open);
          if (_this.detailsEl.open === true) {
            clearInterval(_this_opening_interval);
          } else {
            _this.detailsEl.open = true;
            _this.open();
          }
        }, 100);
        */
      }
      this.attachListeners();

      //console.log('collapsible-details', this);
    }

    removeListeners() {}

    canHover() {
      return this.hasAttribute('data-hover') && !window.Helpers.RWD.isMobile;
    }
    shouldBeOpened() {
      /*
      console.log(
        window.Helpers.RWD.currentBreakpoint + '-open',
        this.detailsEl.hasAttribute(window.Helpers.RWD.currentBreakpoint + '-open'),
      );
      */
      return this.detailsEl.hasAttribute(window.Helpers.RWD.currentBreakpoint + '-open');
      //md-open
    }

    onMouseEnter() {
      if (this.canHover()) this.open();
    }
    onMouseLeave() {
      if (this.canHover()) this.close();
    }
    onClick(e) {
      if (
        (this.shouldBeOpened() && e.target.closest('summary') === this.summaryEl) ||
        (this.canHover() &&
          e.target.nodeName !== 'A' &&
          e.target.nodeName !== 'BUTTON' &&
          !e.target.closest('a[href]') &&
          !e.target.closest('summary'))
      ) {
        e.preventDefault();
        //e.stopPropagation();
        //return false;
      }
    }
    onLinkClick(e) {
      e.preventDefault();
      this.toggle();
    }
    onDocumentClick(e) {
      if (!this.canHover() && !this.shouldBeOpened()) {
        //console.log('close by collapsible.js', this);
        if (!this.contains(e.target)) this.close();
      }
    }

    attachListeners() {
      const _this = this;
      if (this.canHover()) {
        this.detailsEl.addEventListener('mouseenter', this.onMouseEnter.bind(this));
        this.detailsEl.addEventListener('mouseleave', this.onMouseLeave.bind(this));
      }
      this.detailsEl.addEventListener('click', this.onClick.bind(this));
      //document.addEventListener('click', this.onDocumentClick.bind(this));
      if (this.summaryEl.querySelector('a[href]')) {
        this.summaryEl.querySelector('a[href]').addEventListener('click', this.onLinkClick.bind(this));
      }
      window.addEventListener('rwd:bp-change', () => {
        if (_this.shouldBeOpened()) {
          _this.open();
        } else {
          _this.close();
        }
      });
    }

    onFocusOut() {
      requestAnimationFrame(() => {
        if (!this.contains(document.activeElement)) this.close();
      });
    }

    toggle() {
      this.detailsEl.open ? this.close() : this.open();
    }

    open() {
      const _this = this;
      _this.detailsEl.open = true;
      if (_this.detailsEl.querySelector('custom-grid')) {
        requestAnimationFrame(() => {
          _this.detailsEl.querySelector('custom-grid').update();
        });
      }
      let hasFocuedInput = false;
      if (_this.detailsEl.querySelector('input')) {
        _this.detailsEl.querySelectorAll('input').forEach((input) => {
          if (!hasFocuedInput && input.type !== 'hidden' && (input.offsetWidth > 0 || input.offsetHeight > 0)) {
            hasFocuedInput = true;
            setTimeout(function () {
              //console.log('input', input);
              input.focus();
            }, 300);
          }
        });
      }
    }

    close() {
      this.detailsEl.removeAttribute('open');
    }
  }
  customElements.define('collapsible-details', CollapsibleDetails);
}
